import { useState, useEffect } from "react";
import {
  LayoutDashboard,
  FileText,
  Settings,
  ChevronLeft,
  ChevronRight,
  LogOut,
  Plus,
  Upload,
  List
} from "lucide-react";

import { useLocation, useNavigate } from "react-router-dom";
import logo from "../ntt-logo-white.webp";
import api from "../api";

const menu = [
  { key: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/dashboard" },
  { key: "create-form", label: "Create Form", icon: Plus, path: "/create-form" },
  { key: "merchant-config", label: "Merchant Config", icon: Settings, path: "/merchant-config" },
  { key: "my-forms", label: "My Forms", icon: FileText, path: "/my-forms" },
  { key: "upload-master-data", label: "Upload Master Data", icon: Upload, path: "/upload-master-data" },
  { key: "all-transactions", label: "All Transactions", icon: List, path: "/all-transactions" },
];

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(() => {
    return JSON.parse(localStorage.getItem("sidebar")) ?? true;
  });

  useEffect(() => {
    localStorage.setItem("sidebar", JSON.stringify(collapsed));
  }, [collapsed]);

const encoded = localStorage.getItem("role");

// If no role is found, redirect to login
if (!encoded) {
          window.location.href = "/gfb-admin/login"; 
}

const role = atob(encoded);


const filteredMenu = menu.filter(item => {
  if (item.key === "dashboard") {
    return true;
  }
  if (role === "VIEWER") {
    return item.key === "my-forms";
  }
  if (role === "MERCHANT") {
    return item.key !== "merchant-config";
  }
  if (role === "SUPERADMIN") {
    return item.key !== "all-transactions";
  }
  // SUPERADMIN gets all
  return true;
});


  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + "/");

  return (
    <aside className={`px-sidebar ${collapsed ? "collapsed" : ""}`}>
      <div className="px-brand-row">
        <div
          className={`px-brand ${collapsed ? "collapsed" : ""}`}
          onClick={() => navigate("/dashboard")}
          role="button"
          aria-label="Go to dashboard"
          style={{ cursor: "pointer" }}
        >
          <div className="px-brand-logo animate-logo">
            <img src={logo} alt="logo" />
          </div>

          {!collapsed && (
            <div className="px-brand-text">
<div className="px-brand-title">
  Welcome, {role === "VIEWER" 
    ? "User" 
    : role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()}
</div>
              <div className="px-brand-sub">v2.1.2</div>
            </div>
          )}
        </div>

        <div className="px-sidebar-header">
          <button
            className="px-hamburger"
            aria-label="Toggle sidebar"
            onClick={() => setCollapsed(!collapsed)}
          >
            {collapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
          </button>
        </div>
      </div>

      {/* role-based nav */}
      <nav className="px-nav">
        {filteredMenu.map(item => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <button
              key={item.key}
              className={`px-nav-item ${active ? "active" : ""}`}
              data-tooltip={item.label}
              onClick={() => navigate(item.path)}
            >
              <span className="px-icon-wrap">
                <Icon size={18} />
              </span>
              {!collapsed && <span>{item.label}</span>}
            </button>
          );
        })}
      </nav>

      <button
        className="px-logout px-nav-item"
        data-tooltip="Logout"
        onClick={() => {
          localStorage.clear();
          localStorage.clear();
          api.setToken(null);
          localStorage.removeItem("sidebar");
          window.location.href = "/gfb-admin/login"; 
        }}
      >
        <span className="px-icon-wrap logout">
          <LogOut size={18} />
        </span>
        {!collapsed && <span>Logout</span>}
      </button>
    </aside>
  );
}
